import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ItemToSell, ItemToSellState } from 'src/app/_services';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'item-tile',
  templateUrl: './item-tile.component.html',
  styleUrls: ['./item-tile.component.scss']
})
export class ItemTileComponent {
  
  @Input() item: ItemToSell
  
  picturesUrl = environment.picturesUrl;
  
  constructor(private router: Router) {
  }
  
  async viewListing() {
    this.router.navigate(['/view-listing/' + this.item.id]);
  }
  
  get showPrice(): boolean {
    return ItemToSellState.LISTED === this.item?.state;
  }
}
